var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEnum } from 'class-validator';
import { FeatureFlagType } from '../enums/feature-flag-type.enum.js';
/**
 * One flag as the feature-flag switch shows it for the caller's office
 * (TM-9588): every `FeatureFlagType`, whether or not `pt_feature_flag` has a
 * row for it.
 */
export class OfficeFeatureFlagStateDto {
    type;
    /** The office is in `pt_feature_flag_office` for this flag. */
    enabled;
    /**
     * `pt_feature_flag` has a row for this type. Without one the flag cannot be
     * switched on — fixtures do not seed every type — so it is listed rather
     * than left out.
     */
    seeded;
}
__decorate([
    IsEnum(FeatureFlagType),
    __metadata("design:type", String)
], OfficeFeatureFlagStateDto.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], OfficeFeatureFlagStateDto.prototype, "enabled", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], OfficeFeatureFlagStateDto.prototype, "seeded", void 0);
export class SwitchOfficeFeatureFlagDto {
    enabled;
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], SwitchOfficeFeatureFlagDto.prototype, "enabled", void 0);
//# sourceMappingURL=office-feature-flag-state.dto.js.map